module.exports = __webpack_public_path__ + "static/media/studio-pro-mobile@3x.c810e8a9.png";